/* 🤖 this file was generated by svg-to-ts */
export const siriusMagnifyingGlass: {
  name: 'magnifying_glass';
  data: string;
} = {
  name: 'magnifying_glass',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.875 2.25a8.625 8.625 0 1 0 5.546 15.231l4.049 4.05a.75.75 0 1 0 1.06-1.061l-4.049-4.05a8.625 8.625 0 0 0-6.606-14.17ZM3.75 10.875a7.125 7.125 0 1 1 14.25 0 7.125 7.125 0 0 1-14.25 0Z" fill="currentColor"/></svg>`
};
